import { createFileRoute, Link, Outlet, redirect, useRouter } from '@tanstack/react-router';
import { api } from '@/lib/api';
import { clearAdminSession, getAdminUser, setAdminSession, type AdminUser } from '@/lib/session';
import { Button } from '@/components/ui/button';

export const Route = createFileRoute('/admin')({
  beforeLoad: async ({ location }) => {
    // /admin/login is nested under this layout; skip the guard so the redirect
    // to /admin/login doesn't trigger beforeLoad again and create an infinite loop.
    if (location.pathname.startsWith('/admin/login')) return;
    if (getAdminUser()) return;
    try {
      const result = await api.post<{ accessToken: string; adminUser: AdminUser }>('/v1/admin/auth/refresh');
      setAdminSession(result.accessToken, result.adminUser);
    } catch {
      throw redirect({ to: '/admin/login' });
    }
  },
  component: AdminShell,
});

function AdminShell() {
  const router = useRouter();

  async function handleLogout() {
    try {
      await api.post<void>('/v1/admin/auth/logout');
    } catch (err) {
      console.error(err);
    }
    clearAdminSession();
    void router.navigate({ to: '/admin/login' });
  }

  return (
    <div className="min-h-screen bg-background">
      <nav className="sticky top-0 z-10 border-b border-border bg-background px-6 py-3 flex items-center gap-4">
        <Link to="/admin" className="font-bold text-foreground hover:opacity-80">Mow</Link>
        <span className="text-xs text-muted-foreground border border-border rounded px-1.5 py-0.5">Admin</span>
        <Link to="/admin/users" className="text-sm text-muted-foreground hover:text-foreground">Users</Link>
        <Link to="/admin/properties" className="text-sm text-muted-foreground hover:text-foreground">Properties</Link>
        <div className="flex-1" />
        <Button variant="ghost" size="sm" onClick={() => { void handleLogout(); }}>
          Logout
        </Button>
      </nav>
      <main className="p-6">
        <Outlet />
      </main>
    </div>
  );
}
